<template>
  <div class="downloadMask2 pa center pr txtCon tal" v-if="isShowTxt">
    <h4 class="clearfix">通告</h4>
    <b class="pa closeBtn cp" @click="isShowTxt = !isShowTxt">×</b>
    <div class="inCon">
      <p class="f14 fw" style="margin-bottom: 5px;">【v3版维护大师新版本发布通知】</p>
      <p>本次维护大师v3新版本，带来的众多全新功能：</p>
      <p style="text-indent: 2em;">1.文件分发：支持1GB单文件或文件夹分发。支持服务器、客户机任务。</p>
      <p style="margin: 5px 0;text-indent: 2em;">2.桌面管理：上线桌面壁纸管理功能，支持1张壁纸多套分辨率，满足多分辨率都能用高清壁纸需求。桌标排序功能正在开发中，敬请期待。</p>
      <p style="text-indent: 2em;">3.安心玩：服务器防入侵+客户机反外挂/防盗号联动防护；与腾讯ACE深度对接，彻底解决"预启动"弹窗报错。</p>
      <p style="margin-top: 10px;">若您想使用新功能，需联系商务开通相关功能并升级到V3版本使用。</p>
      <p>v3版维护大师入口：<a href="https://zhiweicloud.com" class="mainCol f14 fw">https://zhiweicloud.com</a>（可在工作台下载v3版app、服务端、客户端软件）。</p>
      <p style="margin-top: 10px;color: red;">注意事项：</p>
      <p style="text-indent: 2em;">1.文件分发：为提高分发效率和分发能力，该功能会在服务器游戏盘或服务端安装盘符根目录按需生成“ptfCacheV1C”或“ptfCacheV1S”文件夹，用于存储客户机任务和服务器任务以及产品必要组件程序包，属正常现象。</p>
      <p style="text-indent: 2em;">2.支持版本：V3服务端：<b class="f14 fw">3.1.0.0</b>版、V3客户端：<b class="f14 fw">3.1.2.61</b>版本，需升级到以上版本。</p>
      <p>如有任何疑问，可联系技术支持与商务解决。</p>
      <!-- <p>但由于v2与v3版本规则不兼容，客户端升级到v3后需要您到v3官网<a href="https://zhiweicloud.com" class="mainCol f14 fw">https://zhiweicloud.com</a>重新配置规则，否则会因为未配置规则而导致拦截失效。</p> -->
      <!-- <h4 class="f14 fw marginTop10 tal">版本号说明：</h4>
      <p>v2版本指：客户端版本号以<b class="f14 fw">2</b>开头或<b>3.0.0.78</b></p>
      <p>v3版本指：客户端版本号以<b class="f14 fw">3.1</b>开头为<b>v3</b>版本</p>
      <p>v3最新正式版：<b class="f14 fw">3.1.2.34</b></p> -->
    </div>
    <div class="btnCon tac">
      <Button type="primary" @click="suerAgree">我知道了</Button>
    </div>
  </div>
</template>
<script>
import infoCom from "./info.vue";
import infoCom2 from "./info2.vue";
import infoCom3 from "./info3.vue";
export default {
  props: ["type"],
  components: {
    infoCom,
    infoCom2,
    infoCom3,
  },
  data() {
    return {
      isShowTxt: false,
      isType: 1,
    };
  },
  watch: {
    isType() {
      this.type = this.isType;
    },
  },
  methods: {
    suerAgree() {
      this.$emit("suerAgree");
    },
  },
};
</script>
<style lang="scss" scoped>
.txtCon {
  width: 800px;
  padding-bottom: 10px;
  .inCon {
    overflow: hidden;
    height: 450px;
    overflow-y: auto;
    text-align: left;
  }
}
.marginTop10 {
  margin-top: 20px !important;
}
.downloadMask2 {
  background-color: #f3f3f3;
  background: -webkit-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: -moz-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: -o-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: linear-gradient(to bottom, #f8f8f8 0, #eeeeee 20%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#F8F8F8, endColorstr=#eeeeee, GradientType=0);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.6);
  width: 620px;
  padding: 0 10px 10px;
  box-sizing: border-box;
  border: 1px solid rgb(2, 83, 158);
  overflow: hidden;
  z-index: 999;

  h4 {
    font-size: 14px;
    text-align: left;
    text-indent: 10px;
    line-height: 36px;
    background: rgb(2, 83, 158);
    color: #fff;
    width: 358px;
    margin-left: -10px;

    img {
      margin: 10px 0 0 10px;
    }
  }

  &.txtCon {
    h4 {
      width: 670px;
    }
  }

  .closeBtn {
    font-size: 30px;
    right: 10px;
    top: -4px;
    color: #fff;
  }

  .inCon {
    width: 100%;
    background: #fff;
    border: 1px solid rgb(2, 83, 158);
    margin-top: 10px;
    padding: 10px 20px;

    h4,
    h3 {
      background: #fff;
      color: #000000;
      text-align: center;
      font-size: 18px !important;
      font-weight: bold;
    }

    h3 {
      margin: 10px 0;
    }

    h4 {
      font-size: 14px !important;
      text-align: left;
      line-height: 24px !important;
      margin: 10px 0;
    }

    p {
      line-height: 24px;
    }
  }

  a.contentCon {
    line-height: 90px;
    text-decoration: underline;
  }

  .contentCon {
    height: 90px;
    text-indent: 0px;

    img {
      width: 40px;
    }
  }
}

.btnCon {
  margin-top: 10px;
}
</style>
<style lang="scss" >
.MsoNormal {
  font-size: 14px;
}

.agreementCon {
  b {
    font-weight: bolder !important;
  }

  p {
    line-height: 30px;
  }
}
</style>
